export default __webpack_public_path__ + "static/media/97635.feb6a75a.jpg";